export default __webpack_public_path__ + "static/media/coinBag.e61f9fd8.png";